import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { logger } from '@zep/core-logger';
import { Error500Widget } from './error-widgets';
import { ErrorPageWrapper } from './ErrorPageWrapper';
type Error500Props = {
  error?: Error | unknown;
  onResetError?(): void;
};
export const Error500PageView = (props: Error500Props) => {
  const {
    error,
    onResetError
  } = props;
  const {
    ready
  } = useTranslation(['common']);
  useEffect(() => {
    let filteredErrorData: unknown;
    if (error instanceof AxiosError) {
      filteredErrorData = filterNetworkErrorAdditionalData(error);
    } else {
      filteredErrorData = error;
    }
    logger.track('enteredError500PageView', {
      error: filteredErrorData
    });
    const notifyErrorParentWindow = () => {
      // Serialize error for postMessage (structured clone algorithm)
      const serializedError = error instanceof Error ? {
        name: error.name,
        message: error.message,
        stack: error.stack
      } : typeof error === 'string' ? {
        message: error
      } : {
        message: 'Unknown error'
      };
      window.parent.postMessage({
        type: 'ZEP_500_ERROR',
        payload: serializedError
      }, '*');
    };
    notifyErrorParentWindow();
    return () => {
      onResetError && onResetError();
    };
  }, [error, onResetError]);
  if (!ready) return null;
  return <ErrorPageWrapper data-sentry-element="ErrorPageWrapper" data-sentry-component="Error500PageView" data-sentry-source-file="Error500PageView.tsx">
      <Error500Widget data-sentry-element="Error500Widget" data-sentry-source-file="Error500PageView.tsx" />
    </ErrorPageWrapper>;
};

//FIXME: 일단 axios error config에서, baseURL과 params 정보만 로깅합니다.
const filterNetworkErrorAdditionalData = (error: AxiosError) => {
  const {
    config
  } = error;
  if (config) {
    return {
      ...error,
      config: {
        baseURL: config.baseURL,
        params: config.params
      }
    };
  }
  return error;
};